var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutsideLinkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".right-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33353 2.79995C3.19208 2.79995 3.05642 2.85614 2.9564 2.95616C2.85639 3.05618 2.8002 3.19184 2.8002 3.33328V12.6666C2.8002 12.8081 2.85639 12.9437 2.9564 13.0437C3.05642 13.1438 3.19208 13.2 3.33353 13.2H12.6669C12.8083 13.2 12.944 13.1438 13.044 13.0437C13.144 12.9437 13.2002 12.8081 13.2002 12.6666V9.33328C13.2002 8.89146 13.5584 8.53328 14.0002 8.53328C14.442 8.53328 14.8002 8.89146 14.8002 9.33328V12.6666C14.8002 13.2324 14.5754 13.775 14.1754 14.1751C13.7753 14.5752 13.2327 14.8 12.6669 14.8H3.33353C2.76773 14.8 2.22511 14.5752 1.82503 14.1751C1.42496 13.775 1.2002 13.2324 1.2002 12.6666V3.33328C1.2002 2.76749 1.42496 2.22487 1.82503 1.82479C2.22511 1.42471 2.76773 1.19995 3.33353 1.19995H6.66686C7.10869 1.19995 7.46686 1.55812 7.46686 1.99995C7.46686 2.44178 7.10869 2.79995 6.66686 2.79995H3.33353ZM9.86686 1.99995C9.86686 1.55812 10.225 1.19995 10.6669 1.19995H14.0002C14.442 1.19995 14.8002 1.55812 14.8002 1.99995V5.33328C14.8002 5.77511 14.442 6.13328 14.0002 6.13328C13.5584 6.13328 13.2002 5.77511 13.2002 5.33328V3.93132L9.56588 7.56564C9.25346 7.87806 8.74693 7.87806 8.43451 7.56564C8.12209 7.25322 8.12209 6.74669 8.43451 6.43427L12.0688 2.79995H10.6669C10.225 2.79995 9.86686 2.44178 9.86686 1.99995Z",
    fill: "#171923",
    fillOpacity: 0.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsideLinkDark);
export default __webpack_public_path__ + "static/media/OutsideLinkDark.3d82bf0fe721c1b55aff252494fa343e.svg";
export { ForwardRef as ReactComponent };